import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'configured/axios';
import ListCard from './ListCard';

const MyLists = () => {
  const [lists, setLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [view, setView] = useState('active'); // 'active' | 'archived'

  useEffect(() => {
    setLoading(true);
    setError(null);
    const url = view === 'archived' ? '/api/lists?status=archived' : '/api/lists';
    axios.get(url)
      .then(response => {
        setLists(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to load your lists.');
        setLoading(false);
      });
  }, [view]);

  if (loading) return <p>Loading...</p>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  const isArchivedView = view === 'archived';

  return (
    <>
      <h1 className="mb-4">{isArchivedView ? 'Archived' : 'My Lists'}</h1>

      <div className="row mb-3">
        <div className="col-12">
          {isArchivedView ? (
            <button
              type="button"
              className="btn btn-link p-0"
              onClick={() => setView('active')}
            >
              Back to active lists
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-link p-0"
              onClick={() => setView('archived')}
            >
              Archived
            </button>
          )}
        </div>
      </div>

      {!isArchivedView && (
        <div className='row mb-4'>
          <div className="col-12">
            <Link to="/lists/new" className="btn btn-primary">
              Create a New List
            </Link>
          </div>
        </div>
      )}

      {lists.length === 0 ? (
        <p>
          {isArchivedView
            ? 'No archived lists.'
            : "You haven't created any lists yet."}
        </p>
      ) : (
        <div className="row">
          {lists.map(list => (
            <div key={list.id} className="col-md-6 col-lg-4 mb-4">
              <ListCard list={list} />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default MyLists;
